// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__zvIMP","inner":"Footer_inner__3hJUB","nextIcon":"Footer_nextIcon__3DeNh","innerLeft":"Footer_innerLeft__2Pem8"};